import { render, staticRenderFns } from "./ConfirmSignIn.vue?vue&type=template&id=2b0d7aeb&"
import script from "./ConfirmSignIn.vue?vue&type=script&lang=js&"
export * from "./ConfirmSignIn.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmSignIn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports